module.exports = __webpack_public_path__ + "img/img_red.bd257870.png";